export function fileNameFromLayer(name: string): string {
  const safe = name
    .normalize("NFD")
    .replace(/[̀-ͯ]/g, "") // strip accents/diacritics
    .toLowerCase()
    .replace(/\s+/g, "_")
    .replace(/[^a-z0-9._-]/g, "_") // keep only storage-key-safe chars
    .replace(/_+/g, "_")
    .replace(/^[._-]+|[._-]+$/g, "");
  return safe || "layer";
}

export function slugifyId(name: string): string {
  return name
    .toLowerCase()
    .trim()
    .replace(/\s+/g, "-")
    .replace(/[/\\?%*:|"<>]/g, "");
}

export function uniqueImageName(
  base: string,
  used: Set<string>,
  ext = "png",
): string {
  const root = fileNameFromLayer(base);
  let candidate = `${root}.${ext}`;
  let i = 1;
  while (used.has(candidate)) {
    candidate = `${root}_${i}.${ext}`;
    i++;
  }
  used.add(candidate);
  return candidate;
}
